import { getJSONCriteria } from 'modules/jsonRulesCriterias/businessCriteria';
import { FinanceProgramForm } from '../schema';

export function mapCriteriaFormValuesToCreateInput(formValue: FinanceProgramForm, accountId: string) {
  const programAvailableForLenders = formValue.program.first.lenders.map(({ value }) => value);

  return {
    accountId,
    notes: '',
    guidelines: '',
    financeProgramIdsToLink: [],
    name: formValue.program.first.displayName,
    lenderProfileIdsToLink: programAvailableForLenders,
    jsonCriteria: getJSONCriteria(formValue.program.third?.conditions),
  };
}
